import type { Build } from '@todesktop/shared';
import { doc, getDoc } from 'firebase/firestore';
import firestore from './firestore';
import { readDocumentSnapshot } from './firestoreData';
import logger from './logger';

export default async function getBuildById({
  appId,
  buildId,
  userId,
}: {
  appId: string;
  buildId: string;
  userId: string;
}): Promise<Build | null> {
  logger.debug({ appId, buildId }, 'getBuildById');
  const snapshot = await getDoc(
    doc(firestore, `users/${userId}/applications/${appId}/builds/${buildId}`),
  );

  if (!snapshot.exists()) {
    return null;
  }

  return readDocumentSnapshot<Build>(snapshot) ?? null;
}
